import React  from 'react';
import {  Link } from 'react-router-dom'; 

import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer'; 
import AboutHome from '../components/AboutHome'; 
import WhyChooseHome from '../components/WhyChooseHome'; 
import BlogsHome from '../components/BlogsHome';  
import GetInTouch from '../components/GetInTouch'; 
import { base_url} from '../common/Constants';
import { Helmet } from "react-helmet";

 
class Home extends React.Component{

    constructor(){
        super();
        this.state = { 
            content:[],
            loading:true,
            banners:[],
            products:[],
            divisions:[],
            projects:[],
            services:[],
            clients:[],
            metas:[]
        }
    }
     
    componentDidMount()
    {
       
        if(this.state.loading === true)
       {
        
        this.setState({banners:JSON.parse(localStorage.getItem("banners"))});
        this.setState({content:JSON.parse(localStorage.getItem("content"))});   
        this.setState({metas:JSON.parse(localStorage.getItem("metas"))}); 
        this.setState({loading:false});
        this.setState({clients:JSON.parse(localStorage.getItem("clients"))}); 
        
       }
      
    }
   

    render()
    {
        if (this.state.loading) {
            return <div>Loading...</div>;
          }
        return (
<div>
          
          <div data-v-e8f34808="">
       
      <Header/> 
      <Helmet>
      <title>{this.state.metas[0].title}</title>  
        <meta name="description" content={this.state.metas[0].meta_description} />
        <meta name="keywords" content={this.state.metas[0].meta_title} />
        <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
        <link rel="canonical" href={base_url} />
      </Helmet>

 <div class="home-block" data-v-2705dceb="">
        <div class="home-video" data-aos="fade-in" data-aos-duration="2000" data-v-2705dceb="">
         <video data-v-2705dceb="" loop="loop" muted="muted" playsinline="" preload="auto" autoPlay src={this.state.banners[0].video} webkit-playsinline="" x5-playsinline="" x5-video-orientation="portraint" x5-video-player-fullscreen="true" x5-video-player-type="h5">
         </video>
         <div class="video-filter" data-v-2705dceb="">
         </div>
        </div>
        <div class="home-headline" data-aos="fade-up" data-aos-duration="2000" data-v-2705dceb="">
         <div class="headline-content" data-v-2705dceb="">
          THINKING
          <b data-v-2705dceb="">
           OUTSIDE
          </b>
          <br data-v-2705dceb=""/>
          THE
          <b data-v-2705dceb="">
           BARREL
          </b>
         </div>
        </div>
       </div>
        <div class="service-cards" data-v-4028cc74="">
        <div class="services-scroll" data-v-4028cc74="">
         <div class="scroll-title" data-v-4028cc74="">
          EXPLORE ESTA
         </div>
       <img alt="scroll down" class="scroll-arrow" data-v-4028cc74="" loading="lazy" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJiIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMi43NCAyMi42NiI+PGRlZnM+PHN0eWxlPi5ke2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9ImMiPjxnPjxwb2x5Z29uIGNsYXNzPSJkIiBwb2ludHM9IjEyLjc0IDYuMzIgMTIuNzQgMCA2LjM3IDYuMzcgMCAwIDAgNi4zMiA2LjM3IDEyLjY5IDEyLjc0IDYuMzIiLz48cG9seWdvbiBjbGFzcz0iZCIgcG9pbnRzPSIxMi43NCAxNi4yOSAxMi43NCA5Ljk3IDYuMzcgMTYuMzQgMCA5Ljk3IDAgMTYuMjkgNi4zNyAyMi42NiAxMi43NCAxNi4yOSIvPjwvZz48L2c+PC9zdmc+"/>
        </div>
      <AboutHome content={this.state.content}/> 
      </div>
      <WhyChooseHome content={this.state.content}/>
      <BlogsHome blogs={JSON.parse(localStorage.getItem("blogs"))}/>
      <GetInTouch content={JSON.parse(localStorage.getItem("content"))}/>
     {/******** <ProjectsHome  content={this.state.content} divisions={this.state.divisions}/>

      <FeaturedHome  content={this.state.content}  services={this.state.services} /> 
     
      <ClientsHome content={this.state.content}  clients={this.state.clients}/>
       <BlogsHome  content={this.state.content} projects={this.state.projects}/> *******/}
       
      <Footer/>
        
      </div>
       </div>
      
      
      
       
        )
    }

}
export default Home;